var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('v-alert',{attrs:{"show":"","type":"success"}},[_vm._t("default",function(){return [_vm._v("Info message, please fill in the slot")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }